<template>
  <div>
    <div class="welcome-modal-header-block">
            <p class="welcome-modal-header welcome-modal-header-sm">
              {{ $resourceString["virtualtray.welcomemodal.header"] }}
            </p>
            <p class="welcome-modal-subheader welcome-modal-subheader-sm">
              {{ $resourceString["virtualtray.welcomemodal.subheader"] }}
            </p>
          </div>
          <div class="welcome-modal-body">
            <div class="welcome-modal-step welcome-modal-step-sm">
              <div class="welcome-modal-step-header">
                <b>{{ $resourceString["virtualtray.welcomemodal.step1"] }}</b>
                {{ $resourceString["virtualtray.welcomemodal.step1.header"] }}
              </div>
              {{ $resourceString["virtualtray.welcomemodal.step1.description"] }}
            </div>
            </div>
            <div class="welcome-modal-step welcome-modal-step-sm ">
        <div class="welcome-modal-step-header">
          <b>{{ $resourceString["virtualtray.welcomemodal.step2"] }}</b>
          {{ $resourceString["virtualtray.welcomemodal.step2.header"] }}
        </div>
        {{ $resourceString["virtualtray.welcomemodal.step2.description"] }}
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
</style>